import { RequestResponse, secureRequest, url } from '../utils/request-utils'

export type PersonaleZonenActivate = {
  activate: boolean
}

export function getPersonalezonen(companyID: string): Promise<RequestResponse<PersonaleZonenActivate>> {
  return secureRequest('GET', url('/v2/companies/' + companyID + '/personalezonen'))
}

export function postPersonalezonen(companyID: string): Promise<RequestResponse> {
  return secureRequest('POST', url('/v2/companies/' + companyID + '/personalezonen'))
}

export function postPersonalezonenAll(companyID: string): Promise<RequestResponse> {
  return secureRequest('POST', url('/v2/companies/' + companyID + '/personalezonen/all'))
}

export function deletePersonalezonen(companyID: string): Promise<RequestResponse> {
  return secureRequest('DELETE', url('/v2/companies/' + companyID + '/personalezonen'))
}
